"use client"
import type React from "react"
import { motion } from "framer-motion"

export const ToggleSwitch: React.FC<{
  name: string
  checked: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}> = ({ name, checked, onChange, disabled }) => (
  <label className="relative inline-flex items-center cursor-pointer">
    <input type="checkbox" name={name} checked={checked} onChange={onChange} disabled={disabled} className="sr-only" />
    <motion.div
      initial={false}
      animate={{
        backgroundColor: checked ? "#333333" : "#E5E5E5",
      }}
      className={`w-9 h-5 rounded-full transition-colors duration-200 ease-in-out ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      <motion.div
        initial={false}
        animate={{
          x: checked ? 18 : 2,
        }}
        transition={{ type: "spring", stiffness: 500, damping: 30 }}
        className="w-4 h-4 bg-white rounded-full absolute top-0.5"
      />
    </motion.div>
  </label>
)
